import { Splide } from '@splidejs/splide';
// import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener("DOMContentLoaded", () => {

    init_imageScrollBlock();

    init_coverSliderBlock();

} );

function init_imageScrollBlock(){

    let sliders = document.querySelectorAll('.image-scroll-slider--splide');

    if( sliders.length == 0 ) return;

    const args = {
        type   : 'loop',
        pagination: false,
        arrows: false,
        drag   : 'free',
        focus  : 'center',
        perPage: 8,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplay: true,
        speed: 1500,
        interval: 3000,
        // Add your breakpoints here
        breakpoints: {
            1600: {
                perPage: 6
            },
            1400: {
                perPage: 5
            },
            768: {
                perPage: 3
            },
            580: {
                perPage: 2
            }
        }
        // autoScroll: {
        //     speed: 0.2
        // },
    }

    Array.from(sliders).forEach( slider => new Splide( slider, args ).mount() )

}

function init_coverSliderBlock(){

    let coverSliders = document.querySelectorAll('.cover-slider');

    if( coverSliders.length == 0 ) return;

    const args = {
        type   : 'loop',
        pagination: false,
        arrows: true,
        perPage: 1,
        autoplay: true,
        speed: 800,
        interval: 8000
    }

    Array.from(coverSliders).forEach(slider => {

        // add slide class to covers
        let coverBlocks = slider.querySelectorAll('.wp-block-cover');
        if(coverBlocks.length){
            Array.from(coverBlocks).forEach( cover => cover.classList.add('splide__slide') )
        }

        new Splide( slider, args ).mount();
    })
    
}